import { ThemeOptions } from '@material-ui/core';
import logo from './assets/img/logo.png';
import favicon from './assets/img/favicon.ico';
import appleIcon from './assets/img/icon-256x256.png';
import manifest from './manifest.webmanifest';

export const overrides: ThemeOptions = {
  palette: {
    type: 'dark',
    primary: {
      main: '#006c95',
    },
  },
  meta: {
    propertyName: 'Three Fifty Markets',
    propertyOwner: 'Three Fifty Markets',
    propertyDesc: 'TBC',
    logo,
    favicon,
    manifest,
    appleIcon,
    policies: [],
    loginTerms: 'NULL',
  },
};

export default overrides;
